import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, CreditCard } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.complementodigital.shop/cart/40758159638657:1';
export function Pricing() {
  return <section id="pricing" className="py-12 md:py-24 px-4 relative" data-id="element-151">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-[400px] bg-brand-500/20 blur-[100px] rounded-full pointer-events-none" data-id="element-152" />

      <div className="max-w-lg mx-auto relative z-10" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-zinc-900 border-2 border-brand-500 rounded-2xl md:rounded-3xl p-5 md:p-10 text-center shadow-[0_0_50px_rgba(249,115,22,0.15)]" data-id="element-154">
          <motion.div animate={{
          scale: [1, 1.04, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-block bg-brand-500 text-white font-bold px-3 py-1 rounded-full text-[10px] md:text-sm mb-4 md:mb-6 tracking-wide" data-id="element-155">
            OFERTA ESPECIAL DE LANZAMIENTO
          </motion.div>

          <h3 className="text-sm md:text-2xl text-zinc-300 font-medium mb-1 md:mb-2" data-id="element-156">
            ENTRADA COMPLETA A:
          </h3>
          <h2 className="text-2xl md:text-4xl font-bebas text-white mb-5 md:mb-8 leading-tight" data-id="element-157">
            Entrena en Casa™ + 3 Bonus
          </h2>

          <div className="mb-5 md:mb-8" data-id="element-158">
            <div className="text-zinc-500 line-through text-lg md:text-2xl mb-0.5" data-id="element-159">
              $49.990
            </div>
            <div className="text-brand-500 font-bold text-[10px] md:text-sm mb-0.5 uppercase tracking-widest" data-id="element-160">
              HOY SOLO:
            </div>
            <div className="text-5xl md:text-7xl font-bebas text-white text-glow" data-id="element-161">
              $19.990
            </div>
          </div>

          <motion.a href={CHECKOUT_URL} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} animate={{
          boxShadow: ['0 0 15px rgba(249,115,22,0.35)', '0 0 30px rgba(249,115,22,0.6)', '0 0 15px rgba(249,115,22,0.35)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="block w-full bg-brand-500 hover:bg-brand-600 text-white font-bebas text-xl md:text-3xl py-3.5 md:py-5 rounded-xl transition-colors mb-4 md:mb-6 text-center" data-id="element-162">
            🔥 QUIERO EMPEZAR AHORA
          </motion.a>

          <div className="flex flex-wrap justify-center items-center gap-2 md:gap-4 text-[10px] md:text-sm text-zinc-400 font-medium" data-id="element-163">
            <div className="flex items-center gap-1" data-id="element-164">
              <ShieldCheck className="w-3 h-3 md:w-4 md:h-4 text-green-500" data-id="element-165" />{' '}
              Pago seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-166">
              <Zap className="w-3 h-3 md:w-4 md:h-4 text-yellow-500" data-id="element-167" /> Acceso
              inmediato
            </div>
            <div className="flex items-center gap-1" data-id="element-168">
              <CreditCard className="w-3 h-3 md:w-4 md:h-4 text-blue-400" data-id="element-169" />{' '}
              Mercado Pago
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}